import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import RARichTextInput from 'ra-input-rich-text';
import React from 'react';
import { required as requiredFn } from 'react-admin';

const style = {
  root: {
    marginTop: '16px',
    marginBottom: '8px',
  },
  rootWithError: {
    marginTop: '16px',
    marginBottom: '8px',
  },
  header: {
  },
  headerWithError: {
    color: 'red',
  }
}

const RichTextInput = ({ label, classes, isRequired, validate, meta = {}, ...props }) => {
  const { touched, error } = meta;
  const isError = !!(touched && error)
  return (
    <div
      className={isError ? classes.rootWithError : classes.root}
    >
      <Typography
        className={isError ? classes.headerWithError : classes.header}
        color="textSecondary"
        display="block"
        validate={isRequired ? requiredFn() : validate}
        variant="body1"
      >
        {label}
        {isError && `(${touched && error})`}
      </Typography>
      <RARichTextInput
        {...props}
      />
    </div>
  );
}

export default withStyles(style)(RichTextInput)
